import React, { useEffect, useMemo, useState } from "react";

import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import { TextStyle } from "@tiptap/extension-text-style";
import Color from "@tiptap/extension-color";
import Highlight from "@tiptap/extension-highlight";
import TextAlign from "@tiptap/extension-text-align";

import * as FaIcons from "react-icons/fa";

import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaEye,
  FaTimes,
  FaSave,
  FaSearch,
  FaFilter,
  FaBoxOpen,
  FaLayerGroup,
  FaSitemap,
  FaCheckCircle,
  FaBan,
} from "react-icons/fa";

import "./Products.css";
import { BASE_URL } from "../../Config/config";
const API_URL = `${BASE_URL}/products.php`;
const IMAGE_URL = `${BASE_URL}/`;
const DEFAULT_PRODUCT_ICON = "FaBoxOpen";
const DEFAULT_SUBPRODUCT_ICON = "FaLayerGroup";
const USERS_WISE_PLANS = [
  {
    pack_name: "Personal Pack",
    plans: [
      {
        plan_name: "Personal (For 1 User)",
        user_count: 1,
      },
      {
        plan_name: "Regular (For 2 User)",
        user_count: 2,
      },
      {
        plan_name: "Redular Plus (For 4 User)",
        user_count: 4,
      },
      {
        plan_name: "Regular Pro (For 8 User)",
        user_count: 8,
      },
      {
        plan_name: "Performance (For 12 User)",
        user_count: 12,
      },
      {
        plan_name: "Performance Plus (For 16 User)",
        user_count: 16,
      },
    ],
  },
  {
    pack_name: "Performance Pack",
    plans: [
      {
        plan_name: "Performance (For 8 User)",
        user_count: 8,
      },
      {
        plan_name: "Performance Max (For 12 User)",
        user_count: 12,
      },
      {
        plan_name: "Performance Plus (For 16 User)",
        user_count: 16,
      },
      {
        plan_name: "Performance Max Plus (For 24 User)",
        user_count: 24,
      },
      {
        plan_name: "Performance Pro (For 32 User)",
        user_count: 32,
      },
      {
        plan_name: "EnterPrice (For 48 User)",
        user_count: 48,
      },
      {
        plan_name: "EmnterPrice Plus (For 64 User)",
        user_count: 64,
      },
    ],
  },
];
const getPlanKey = (priceCategory, packName, planName) => {
  return `${priceCategory}__${packName}__${planName}`;
};
const formatModulePrice = (price) => {
  if (price === null || price === undefined) {
    return "";
  }

  const value = String(price).trim();

  if (
    value === "" ||
    value === "0" ||
    value === "0.0" ||
    value === "0.00" ||
    value.toLowerCase() === "price on request"
  ) {
    return "";
  }

  const numericPrice = Number(value);

  if (Number.isFinite(numericPrice)) {
    return `₹${numericPrice.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  return value;
};

const createEmptyUsersWisePrices = () => {
  const prices = {};
  ["new", "renewal"].forEach((priceCategory) => {
    USERS_WISE_PLANS.forEach((pack) => {
      pack.plans.forEach((plan) => {
        const key = getPlanKey(priceCategory, pack.pack_name, plan.plan_name);

        prices[key] = "";
      });
    });
  });

  return prices;
};
const FA_ICON_LIST = Object.entries(FaIcons)
  .filter(([name, Icon]) => {
    return (
      name.startsWith("Fa") &&
      (typeof Icon === "object" || typeof Icon === "function")
    );
  })
  .map(([name, Icon]) => ({
    name,
    Icon,
  }))
  .sort((a, b) => a.name.localeCompare(b.name));
export default function Products() {
  const [moduleHighlightColor, setModuleHighlightColor] = useState("#ffff00");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [activeTab, setActiveTab] = useState("product");
  const [subProducts, setSubProducts] = useState([]);
  const [editingProduct, setEditingProduct] = useState(null);
  const [editingSubProduct, setEditingSubProduct] = useState(null);
  const [editingModule, setEditingModule] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [search, setSearch] = useState("");
  const [productFilter, setProductFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [iconSearch, setIconSearch] = useState("");
  const [showProductModal, setShowProductModal] = useState(false);
  const [showSubProductModal, setShowSubProductModal] = useState(false);
  const [showModuleModal, setShowModuleModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSubProduct, setSelectedSubProduct] = useState(null);
  const [selectedModule, setSelectedModule] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [selectedUsersWisePack, setSelectedUsersWisePack] = useState(
    USERS_WISE_PLANS[0]?.pack_name || "",
  );
  const [productForm, setProductForm] = useState({
    name: "",
    description: "",
    status: true,
    display_order: "",
    icon: DEFAULT_PRODUCT_ICON,
  });
  const [subProductForm, setSubProductForm] = useState({
    productId: "",
    name: "",
    description: "",

    icon: DEFAULT_SUBPRODUCT_ICON,
    display_order: "",
  });
  const [moduleForm, setModuleForm] = useState({
    productId: "",
    subProductId: "",
    name: "",
    description: "",
    pricing_type: "fixed",

    singlePrice: "",
    oneYearPrice: "",
    twoYearPrice: "",

    // NEW
    singleUserPrice: "",
    multiUserPrice: "",

    priceCategory: "new",
    usersWisePrices: createEmptyUsersWisePrices(),
    gst: "",
    code: "",
    image: null,
    imagePreview: "",
    display_order: "",
  });
  /* =====================================================
   MODULE DESCRIPTION TIPTAP EDITOR
===================================================== */

  /* =====================================================
   MODULE DESCRIPTION TIPTAP EDITOR
===================================================== */

  const moduleDescriptionEditor = useEditor({
    extensions: [
      StarterKit,
      Underline,
      TextStyle,
      Color,

      Highlight.configure({
        multicolor: true,
      }),

      TextAlign.configure({
        types: ["heading", "paragraph"],
      }),
    ],

    content: "",

    editorProps: {
      attributes: {
        class: "module-tiptap-editor-content",
      },
    },

    onUpdate: ({ editor }) => {
      setModuleForm((prev) => ({
        ...prev,
        description: editor.getHTML(),
      }));
    },
  });

  /* =====================================================
   LOAD DESCRIPTION INTO EDITOR WHEN MODAL OPENS
===================================================== */

  useEffect(() => {
    if (!moduleDescriptionEditor || !showModuleModal) {
      return;
    }

    moduleDescriptionEditor.commands.setContent(
      moduleForm.description || "",
      false,
    );
  }, [moduleDescriptionEditor, showModuleModal, editingModule?.id]);

  /* =====================================================
   SET DESCRIPTION CONTENT
===================================================== */

  const setModuleDescriptionContent = (description) => {
    const html = description || "";

    setModuleForm((prev) => ({
      ...prev,
      description: html,
    }));

    if (moduleDescriptionEditor) {
      moduleDescriptionEditor.commands.setContent(html, false);
    }
  };
  const DynamicFaIcon = ({ name, ...props }) => {
    const IconComponent =
      FaIcons[name] || FaIcons[DEFAULT_PRODUCT_ICON] || FaIcons.FaBoxOpen;

    return <IconComponent {...props} />;
  };
  const getImageUrl = (image) => {
    if (!image) {
      return "";
    }

    if (
      image.startsWith("http://") ||
      image.startsWith("https://") ||
      image.startsWith("blob:")
    ) {
      return image;
    }

    return `${IMAGE_URL}${image}`;
  };
  const filteredFaIcons = useMemo(() => {
    const value = iconSearch.toLowerCase().trim();

    if (!value) {
      return FA_ICON_LIST;
    }

    return FA_ICON_LIST.filter(({ name }) =>
      name.toLowerCase().includes(value),
    );
  }, [iconSearch]);
  const fetchProducts = async () => {
    try {
      setLoading(true);

      const response = await fetch(`${API_URL}?action=get`);

      if (!response.ok) {
        throw new Error(`HTTP Error ${response.status}`);
      }

      const data = await response.json();

      if (!data.status) {
        throw new Error(data.message || "Failed to fetch product data.");
      }

      const productsData = Array.isArray(data.data?.products)
        ? data.data.products
        : [];

      const subProductsData = Array.isArray(data.data?.subProducts)
        ? data.data.subProducts
        : [];
      const productsWithSubProducts = productsData.map((product) => ({
        ...product,

        modules: subProductsData
          .filter(
            (subProduct) =>
              Number(subProduct.product_id) === Number(product.id),
          )
          .sort((a, b) => {
            const orderA = Number(a.display_order || 0);
            const orderB = Number(b.display_order || 0);

            if (orderA !== orderB) {
              return orderA - orderB;
            }

            return Number(a.id) - Number(b.id);
          }),
      }));

      setProducts(productsWithSubProducts);
      setSubProducts(subProductsData);
    } catch (error) {
      console.error("FETCH PRODUCTS ERROR:", error);

      alert(error.message || "Failed to load product data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);
  useEffect(() => {
    AOS.init({
      duration: 700,
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
    });
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 700,
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
    });
  }, []);

  const allSubProducts = useMemo(() => {
    return [...subProducts]
      .map((subProduct) => {
        const product = products.find(
          (item) => Number(item.id) === Number(subProduct.product_id),
        );
        return {
          ...subProduct,
          productId: subProduct.product_id,
          productName: product?.name || "Unknown Product",
        };
      })
      .sort((a, b) => {
        const orderA = Number(a.display_order || 0);
        const orderB = Number(b.display_order || 0);

        if (orderA !== orderB) {
          return orderA - orderB;
        }

        return Number(a.id) - Number(b.id);
      });
  }, [subProducts, products]);
  const allModules = useMemo(() => {
    const result = [];
    subProducts.forEach((subProduct) => {
      const product = products.find(
        (item) => Number(item.id) === Number(subProduct.product_id),
      );

      (subProduct.subcategories || []).forEach((module) => {
        result.push({
          ...module,

          productId: subProduct.product_id,
          productName: product?.name || "Unknown Product",

          subProductId: subProduct.id,
          subProductName: subProduct.name,
        });
      });
    });
    return result.sort((a, b) => {
      const orderA = Number(a.display_order || 0);
      const orderB = Number(b.display_order || 0);

      if (orderA !== orderB) {
        return orderA - orderB;
      }

      return Number(a.id) - Number(b.id);
    });
  }, [subProducts, products]);
  const filteredProducts = useMemo(() => {
    const searchValue = search.toLowerCase().trim();

    return products.filter((product) => {
      const productName = product.name?.toLowerCase() || "";
      const productDescription = product.description?.toLowerCase() || "";

      const searchMatch =
        !searchValue ||
        productName.includes(searchValue) ||
        productDescription.includes(searchValue);

      const productMatch =
        !productFilter || String(product.id) === String(productFilter);

      const statusMatch =
        !statusFilter ||
        (statusFilter === "active" && Boolean(product.status)) ||
        (statusFilter === "inactive" && !Boolean(product.status));

      return searchMatch && productMatch && statusMatch;
    });
  }, [products, search, productFilter, statusFilter]);
  const filteredSubProducts = useMemo(() => {
    const searchValue = search.toLowerCase().trim();

    return allSubProducts.filter((subProduct) => {
      const name = subProduct.name?.toLowerCase() || "";
      const description = subProduct.description?.toLowerCase() || "";
      const productName = subProduct.productName?.toLowerCase() || "";

      const searchMatch =
        !searchValue ||
        name.includes(searchValue) ||
        description.includes(searchValue) ||
        productName.includes(searchValue);

      const productMatch =
        !productFilter ||
        String(subProduct.productId) === String(productFilter);

      return searchMatch && productMatch;
    });
  }, [allSubProducts, search, productFilter]);
  const filteredModules = useMemo(() => {
    const searchValue = search.toLowerCase().trim();

    return allModules.filter((module) => {
      const name = module.name?.toLowerCase() || "";
      const description = module.description?.toLowerCase() || "";
      const productName = module.productName?.toLowerCase() || "";
      const subProductName = module.subProductName?.toLowerCase() || "";
      const code = module.code?.toLowerCase() || "";

      const searchMatch =
        !searchValue ||
        name.includes(searchValue) ||
        description.includes(searchValue) ||
        productName.includes(searchValue) ||
        subProductName.includes(searchValue) ||
        code.includes(searchValue);

      const productMatch =
        !productFilter || String(module.productId) === String(productFilter);

      return searchMatch && productMatch;
    });
  }, [allModules, search, productFilter]);
  const totalProducts = products.length;
  const totalSubProducts = allSubProducts.length;
  const totalModules = allModules.length;
  const tabInfo = {
    product: {
      label: "Products",
      singular: "Product",
      description: "Manage all products and their basic information.",
      addText: "Add Product",
      emptyMessage: "No products found.",
      icon: <FaBoxOpen />,
    },

    subproduct: {
      label: "Sub Products",
      singular: "Sub Product",
      description: "Manage sub products under each product.",
      addText: "Add Sub Product",
      emptyMessage: "No sub products found.",
      icon: <FaLayerGroup />,
    },

    module: {
      label: "Modules",
      singular: "Module",
      description: "Manage modules under each sub product.",
      addText: "Add Module",
      emptyMessage: "No modules found.",
      icon: <FaSitemap />,
    },
  };

  const currentTab = tabInfo[activeTab];
  const changeTab = (tab) => {
    setActiveTab(tab);

    setSearch("");
    setProductFilter("");
    setStatusFilter("");

    setCurrentPage(1);

    setSelectedProduct(null);
    setSelectedSubProduct(null);
    setSelectedModule(null);
  };
  const clearFilters = () => {
    setSearch("");
    setProductFilter("");
    setStatusFilter("");
    setCurrentPage(1);
  };
  useEffect(() => {
    setCurrentPage(1);
  }, [search, productFilter, statusFilter]);
  const openAddProduct = () => {
    setEditingProduct(null);

    setProductForm({
      name: "",
      description: "",
      status: true,
      display_order: "",
      icon: DEFAULT_PRODUCT_ICON,
    });

    setIconSearch("");
    setShowProductModal(true);
  };
  const openEditProduct = (product) => {
    setEditingProduct(product);

    setProductForm({
      name: product.name || "",
      description: product.description || "",
      status: Boolean(Number(product.status)),
      display_order: product.display_order ?? 0,
      icon: product.icon || DEFAULT_PRODUCT_ICON,
    });

    setIconSearch("");
    setShowProductModal(true);
  };
  const saveProduct = async () => {
    if (!productForm.name.trim()) {
      alert("Please enter product name.");
      return;
    }

    try {
      setSaving(true);

      const formData = new FormData();

      formData.append("name", productForm.name.trim());
      formData.append("description", productForm.description.trim());
      formData.append("status", productForm.status ? "1" : "0");
      formData.append("icon", productForm.icon || DEFAULT_PRODUCT_ICON);
      formData.append("display_order", productForm.display_order);
      let action = "add_product";

      if (editingProduct) {
        action = "update_product";
        formData.append("id", editingProduct.id);
      }

      const response = await fetch(`${API_URL}?action=${action}`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (!data.status) {
        throw new Error(data.message || "Failed to save product.");
      }

      alert(
        data.message ||
          `${
            editingProduct ? "Product updated" : "Product added"
          } successfully.`,
      );

      setShowProductModal(false);
      setEditingProduct(null);

      await fetchProducts();
    } catch (error) {
      console.error("SAVE PRODUCT ERROR:", error);

      alert(error.message || "Failed to save product.");
    } finally {
      setSaving(false);
    }
  };

  const deleteProduct = async (id) => {
    const product = products.find((item) => Number(item.id) === Number(id));

    if (!product) {
      return;
    }

    const confirmDelete = window.confirm(
      `Delete "${product.name}" and all its sub products and modules?`,
    );

    if (!confirmDelete) {
      return;
    }

    try {
      setSaving(true);

      const formData = new FormData();
      formData.append("id", id);

      const response = await fetch(`${API_URL}?action=delete_product`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (!data.status) {
        throw new Error(data.message || "Failed to delete product.");
      }

      alert(data.message || "Product deleted successfully.");

      await fetchProducts();
    } catch (error) {
      console.error("DELETE PRODUCT ERROR:", error);

      alert(error.message || "Failed to delete product.");
    } finally {
      setSaving(false);
    }
  };

  const openAddSubProduct = () => {
    setEditingSubProduct(null);

    setSubProductForm({
      productId: "",
      name: "",
      description: "",
      icon: DEFAULT_SUBPRODUCT_ICON,
      display_order: "",
    });

    setIconSearch("");
    setShowSubProductModal(true);
  };

  const openEditSubProduct = (subProduct) => {
    setEditingSubProduct(subProduct);

    setSubProductForm({
      productId: subProduct.productId || "",
      name: subProduct.name || "",
      description: subProduct.description || "",
      icon: subProduct.icon || DEFAULT_SUBPRODUCT_ICON,
      display_order: subProduct.display_order ?? 0,
    });

    setIconSearch("");
    setShowSubProductModal(true);
  };

  const saveSubProduct = async () => {
    if (!subProductForm.productId) {
      alert("Please select a product.");
      return;
    }

    if (!subProductForm.name.trim()) {
      alert("Please enter sub product name.");
      return;
    }

    try {
      setSaving(true);

      const formData = new FormData();

      formData.append("product_id", subProductForm.productId);

      formData.append("name", subProductForm.name.trim());

      formData.append("description", subProductForm.description.trim());

      formData.append("icon", subProductForm.icon || DEFAULT_SUBPRODUCT_ICON);
      formData.append("display_order", subProductForm.display_order);
      let action = "add_sub_product";

      if (editingSubProduct) {
        action = "update_sub_product";

        formData.append("id", editingSubProduct.id);
      }

      const response = await fetch(`${API_URL}?action=${action}`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (!data.status) {
        throw new Error(data.message || "Failed to save sub product.");
      }

      alert(
        data.message ||
          (editingSubProduct
            ? "Sub Product updated successfully."
            : "Sub Product added successfully."),
      );

      setShowSubProductModal(false);
      setEditingSubProduct(null);

      await fetchProducts();
    } catch (error) {
      console.error("SAVE SUB PRODUCT ERROR:", error);

      alert(error.message || "Failed to save sub product.");
    } finally {
      setSaving(false);
    }
  };

  const deleteSubProduct = async (subProduct) => {
    if (!subProduct) {
      return;
    }

    const confirmDelete = window.confirm(
      `Delete "${subProduct.name}" and all its modules?`,
    );

    if (!confirmDelete) {
      return;
    }

    try {
      setSaving(true);

      const formData = new FormData();

      formData.append("id", subProduct.id);

      const response = await fetch(`${API_URL}?action=delete_sub_product`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (!data.status) {
        throw new Error(data.message || "Failed to delete sub product.");
      }

      alert(data.message || "Sub Product deleted successfully.");

      await fetchProducts();
    } catch (error) {
      console.error("DELETE SUB PRODUCT ERROR:", error);

      alert(error.message || "Failed to delete sub product.");
    } finally {
      setSaving(false);
    }
  };

  const openAddModule = () => {
    setEditingModule(null);

    const emptyDescription = "";

    setModuleForm({
      productId: "",
      subProductId: "",
      name: "",
      description: "",

      pricing_type: "fixed",

      singlePrice: "",
      oneYearPrice: "",
      twoYearPrice: "",

      singleUserPrice: "",
      multiUserPrice: "",

      priceCategory: "new",
      usersWisePrices: createEmptyUsersWisePrices(),

      gst: "",
      code: "",
      image: null,
      imagePreview: "",
      display_order: "",
    });

    if (moduleDescriptionEditor) {
      moduleDescriptionEditor.commands.setContent("", false);
    }

    setShowModuleModal(true);
  };
  const normalizePriceForForm = (price) => {
    if (price === null || price === undefined) {
      return "";
    }

    const value = String(price).trim();

    if (
      value === "" ||
      value === "0" ||
      value === "0.0" ||
      value === "0.00" ||
      value.toLowerCase() === "price on request"
    ) {
      return "";
    }

    return value;
  };

  const openEditModule = (module) => {
    setEditingModule(module);

    const pricingType = module.pricing_type || "fixed";
    const description = module.description || "";
    let singlePrice = "";
    let oneYearPrice = "";
    let twoYearPrice = "";

    let singleUserPrice = "";
    let multiUserPrice = "";

    if (pricingType === "fixed") {
      const samePrice = (module.prices || []).find(
        (item) => item.price_category === "same" || !item.price_category,
      );

      singlePrice = normalizePriceForForm(samePrice?.price);
    }

    if (pricingType === "yearly") {
      (module.prices || []).forEach((item) => {
        if (item.price_category === "1_year") {
          oneYearPrice = normalizePriceForForm(item.price);
        }

        if (item.price_category === "2_years") {
          twoYearPrice = normalizePriceForForm(item.price);
        }
      });
    }
    if (pricingType === "single_multi_user") {
      (module.prices || []).forEach((item) => {
        if (item.price_category === "single_user") {
          singleUserPrice = normalizePriceForForm(item.price);
        }

        if (item.price_category === "multi_user") {
          multiUserPrice = normalizePriceForForm(item.price);
        }
      });
    }
    const usersWisePrices = createEmptyUsersWisePrices();

    if (pricingType === "users_wise") {
      (module.prices || []).forEach((item) => {
        if (
          item.price_category === "new" ||
          item.price_category === "renewal"
        ) {
          const key = getPlanKey(
            item.price_category,
            item.pack_name,
            item.plan_name,
          );

          usersWisePrices[key] = normalizePriceForForm(item.price);
        }
      });
    }

    /* =====================================================
     SET FORM
  ===================================================== */

    setModuleForm({
      productId: module.productId || module.product_id || "",

      subProductId: module.subProductId || module.sub_product_id || "",

      name: module.name || "",

      description: description,

      pricing_type: pricingType,

      singlePrice: singlePrice,

      oneYearPrice: oneYearPrice,

      twoYearPrice: twoYearPrice,
      singleUserPrice: singleUserPrice,
      multiUserPrice: multiUserPrice,
      priceCategory: "new",

      usersWisePrices: usersWisePrices,

      gst: module.gst || "",

      code: module.code || "",

      image: null,

      imagePreview: module.image ? getImageUrl(module.image) : "",

      display_order: module.display_order ?? 0,
    });
    if (moduleDescriptionEditor) {
      moduleDescriptionEditor.commands.setContent(description, false);
    }
    setShowModuleModal(true);
  };
  const selectedSubProductList = useMemo(() => {
    return subProducts
      .filter(
        (subProduct) =>
          Number(subProduct.product_id) === Number(moduleForm.productId),
      )
      .sort((a, b) => {
        const orderA = Number(a.display_order || 0);
        const orderB = Number(b.display_order || 0);

        if (orderA !== orderB) {
          return orderA - orderB;
        }

        return Number(a.id) - Number(b.id);
      });
  }, [subProducts, moduleForm.productId]);

  const handleModuleImage = (e) => {
    const file = e.target.files?.[0];

    if (!file) {
      return;
    }

    if (!file.type.startsWith("image/")) {
      alert("Please select a valid image.");
      return;
    }

    const preview = URL.createObjectURL(file);

    setModuleForm((prev) => ({
      ...prev,
      image: file,
      imagePreview: preview,
    }));
  };
  const createUserWisePrices = () => {
    const rows = [];

    USERS_WISE_PLANS.forEach((pack) => {
      pack.plans.forEach((plan) => {
        rows.push({
          pricing_type: "users_wise",
          price_category: "new",
          pack_name: pack.pack_name,
          plan_name: plan.plan_name,
          user_count: plan.user_count,
          price: "",
        });

        rows.push({
          pricing_type: "users_wise",
          price_category: "renewal",
          pack_name: pack.pack_name,
          plan_name: plan.plan_name,
          user_count: plan.user_count,
          price: "",
        });
      });
    });

    return rows;
  };

  const updateUsersWisePrice = (packName, planName, value) => {
    const key = getPlanKey(moduleForm.priceCategory, packName, planName);

    setModuleForm((prev) => ({
      ...prev,

      usersWisePrices: {
        ...prev.usersWisePrices,
        [key]: value,
      },
    }));
  };

  const normalizePrice = (value) => {
    if (value === null || value === undefined) {
      return "";
    }

    const price = String(value).trim();

    if (
      price === "" ||
      price === "0" ||
      price === "0.0" ||
      price === "0.00" ||
      price.toLowerCase() === "price on request"
    ) {
      return "";
    }

    return price;
  };

  const buildModulePrices = () => {
    const prices = [];

    // ==========================================
    // FIXED PRICE
    // ==========================================
    if (moduleForm.pricing_type === "fixed") {
      const price = moduleForm.singlePrice?.toString().trim();

      if (price !== "") {
        prices.push({
          pricing_type: "fixed",
          price_category: "same",
          pack_name: null,
          plan_name: null,
          user_count: null,
          price: price,
        });
      }

      return prices;
    }

    // ==========================================
    // YEARLY PRICE
    // ==========================================
    if (moduleForm.pricing_type === "yearly") {
      const oneYearPrice = moduleForm.oneYearPrice?.toString().trim() || "";

      const twoYearPrice = moduleForm.twoYearPrice?.toString().trim() || "";

      // 1 YEAR
      if (oneYearPrice !== "") {
        prices.push({
          pricing_type: "yearly",
          price_category: "1_year",
          pack_name: null,
          plan_name: null,
          user_count: null,
          price: oneYearPrice,
        });
      }

      // 2 YEARS
      if (twoYearPrice !== "") {
        prices.push({
          pricing_type: "yearly",
          price_category: "2_years",
          pack_name: null,
          plan_name: null,
          user_count: null,
          price: twoYearPrice,
        });
      }

      return prices;
    }
    // ==========================================
    // SINGLE / MULTI USER PRICE
    // ==========================================
    if (moduleForm.pricing_type === "single_multi_user") {
      const singleUserPrice =
        moduleForm.singleUserPrice?.toString().trim() || "";

      const multiUserPrice = moduleForm.multiUserPrice?.toString().trim() || "";

      // SINGLE USER
      if (singleUserPrice !== "") {
        prices.push({
          pricing_type: "single_multi_user",
          price_category: "single_user",
          pack_name: null,
          plan_name: null,
          user_count: 1,
          price: singleUserPrice,
        });
      }

      // MULTI USER
      if (multiUserPrice !== "") {
        prices.push({
          pricing_type: "single_multi_user",
          price_category: "multi_user",
          pack_name: null,
          plan_name: null,
          user_count: null,
          price: multiUserPrice,
        });
      }

      return prices;
    }
    // ==========================================
    // USERS WISE PRICE
    // ==========================================
    if (moduleForm.pricing_type === "users_wise") {
      Object.entries(moduleForm.usersWisePrices || {}).forEach(
        ([key, value]) => {
          const price = value?.toString().trim();

          // IMPORTANT:
          // Empty price = DO NOT SAVE
          if (price === "") {
            return;
          }

          const parts = key.split("__");

          const priceCategory = parts[0];
          const packName = parts[1];
          const planName = parts.slice(2).join("__");

          // Find pack
          const pack = USERS_WISE_PLANS.find(
            (item) => item.pack_name === packName,
          );

          if (!pack) {
            return;
          }

          // Find plan
          const plan = pack.plans.find((item) => item.plan_name === planName);

          if (!plan) {
            return;
          }

          prices.push({
            pricing_type: "users_wise",
            price_category: priceCategory,
            pack_name: packName,
            plan_name: planName,
            user_count: plan.user_count,
            price: price,
          });
        },
      );

      return prices;
    }

    return prices;
  };
  const saveModule = async () => {
    if (!moduleForm.productId) {
      alert("Please select product.");
      return;
    }

    if (!moduleForm.subProductId) {
      alert("Please select sub product.");
      return;
    }

    if (!moduleForm.name.trim()) {
      alert("Please enter module name.");
      return;
    }

    try {
      setSaving(true);

      const formData = new FormData();

      formData.append("product_id", moduleForm.productId);

      formData.append("sub_product_id", moduleForm.subProductId);

      formData.append("name", moduleForm.name.trim());

      formData.append("description", moduleForm.description.trim());

      formData.append("pricing_type", moduleForm.pricing_type);

      const prices = buildModulePrices();

      formData.append("prices", JSON.stringify(prices));

      formData.append("gst", moduleForm.gst.trim());

      formData.append("code", moduleForm.code.trim());

      formData.append("display_order", moduleForm.display_order);

      let action = "add_module";

      if (editingModule) {
        action = "update_module";

        formData.append("id", editingModule.id);
      }

      if (moduleForm.image) {
        formData.append("image", moduleForm.image);
      }

      const response = await fetch(`${API_URL}?action=${action}`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (!data.status) {
        throw new Error(data.message || "Failed to save module.");
      }

      alert(
        data.message ||
          (editingModule
            ? "Module updated successfully."
            : "Module added successfully."),
      );

      setShowModuleModal(false);
      setEditingModule(null);

      setModuleForm({
        productId: "",
        subProductId: "",
        name: "",
        description: "",

        pricing_type: "fixed",

        singlePrice: "",
        oneYearPrice: "",
        twoYearPrice: "",

        singleUserPrice: "",
        multiUserPrice: "",

        priceCategory: "new",
        usersWisePrices: createEmptyUsersWisePrices(),

        gst: "",
        code: "",
        image: null,
        imagePreview: "",
        display_order: "",
      });

      await fetchProducts();
    } catch (error) {
      console.error("SAVE MODULE ERROR:", error);

      alert(error.message || "Failed to save module.");
    } finally {
      setSaving(false);
    }
  };

  const deleteModule = async (module) => {
    if (!module) {
      return;
    }

    const confirmDelete = window.confirm(`Delete module "${module.name}"?`);

    if (!confirmDelete) {
      return;
    }

    try {
      setSaving(true);

      const formData = new FormData();

      formData.append("id", module.id);

      const response = await fetch(`${API_URL}?action=delete_module`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (!data.status) {
        throw new Error(data.message || "Failed to delete module.");
      }

      alert(data.message || "Module deleted successfully.");

      await fetchProducts();
    } catch (error) {
      console.error("DELETE MODULE ERROR:", error);

      alert(error.message || "Failed to delete module.");
    } finally {
      setSaving(false);
    }
  };

  const currentFilteredData =
    activeTab === "product"
      ? filteredProducts
      : activeTab === "subproduct"
        ? filteredSubProducts
        : filteredModules;

  const totalPages = Math.ceil(currentFilteredData.length / itemsPerPage);

  const paginationStartIndex = (currentPage - 1) * itemsPerPage;

  const paginatedData = currentFilteredData.slice(
    paginationStartIndex,
    paginationStartIndex + itemsPerPage,
  );

  const openViewProduct = (product) => {
    setSelectedProduct(product);
    setSelectedSubProduct(null);
    setSelectedModule(null);
    setShowViewModal(true);
  };

  const openViewSubProduct = (subProduct) => {
    setSelectedProduct(null);
    setSelectedSubProduct(subProduct);
    setSelectedModule(null);
    setShowViewModal(true);
  };

  const openViewModule = (module) => {
    setSelectedProduct(null);
    setSelectedSubProduct(null);
    setSelectedModule(module);
    setShowViewModal(true);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
    setSelectedProduct(null);
    setSelectedSubProduct(null);
    setSelectedModule(null);
  };

  const closeProductModal = () => {
    if (saving) return;

    setShowProductModal(false);
    setEditingProduct(null);
    setIconSearch("");
  };

  const closeSubProductModal = () => {
    if (saving) return;

    setShowSubProductModal(false);
    setEditingSubProduct(null);
    setIconSearch("");
  };
  const closeModuleModal = () => {
    if (saving) return;

    setShowModuleModal(false);
    setEditingModule(null);

    setModuleForm({
      productId: "",
      subProductId: "",
      name: "",
      description: "",

      pricing_type: "fixed",

      singlePrice: "",
      oneYearPrice: "",
      twoYearPrice: "",

      singleUserPrice: "",
      multiUserPrice: "",

      priceCategory: "new",

      usersWisePrices: createEmptyUsersWisePrices(),

      gst: "",
      code: "",
      image: null,
      imagePreview: "",
      display_order: "",
    });
  };
  const openImagePopup = (image) => {
    if (!image) return;

    setSelectedImage(getImageUrl(image));
    setShowImageModal(true);
  };

  const closeImagePopup = () => {
    setShowImageModal(false);
    setSelectedImage("");
  };

  const renderPagination = () => {
    if (currentFilteredData.length === 0) {
      return null;
    }

    if (totalPages <= 1) {
      return (
        <div className="pagination-wrapper">
          <div className="pagination-info">
            Showing {currentFilteredData.length} of {currentFilteredData.length}
          </div>

          <div className="pagination-per-page">
            <span>Show</span>

            <select
              value={itemsPerPage}
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
            </select>

            <span>per page</span>
          </div>
        </div>
      );
    }

    const startItem = (currentPage - 1) * itemsPerPage + 1;

    const endItem = Math.min(
      currentPage * itemsPerPage,
      currentFilteredData.length,
    );

    const getPageNumbers = () => {
      const pages = [];

      if (totalPages <= 7) {
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }

        return pages;
      }

      pages.push(1);

      if (currentPage > 4) {
        pages.push("...");
      }

      const start = Math.max(2, currentPage - 2);
      const end = Math.min(totalPages - 1, currentPage + 2);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - 3) {
        pages.push("...");
      }

      pages.push(totalPages);

      return pages;
    };

    return (
      <div className="pagination-wrapper">
        <div className="pagination-info">
          Showing <strong>{startItem}</strong> - <strong>{endItem}</strong> of{" "}
          <strong>{currentFilteredData.length}</strong>
        </div>

        <div className="pagination-controls">
          <button
            type="button"
            className="pagination-btn"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          >
            <FaIcons.FaChevronLeft />
          </button>

          {getPageNumbers().map((page, index) => {
            if (page === "...") {
              return (
                <span key={`dots-${index}`} className="pagination-dots">
                  ...
                </span>
              );
            }

            return (
              <button
                type="button"
                key={page}
                className={`pagination-btn ${
                  currentPage === page ? "active" : ""
                }`}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </button>
            );
          })}

          <button
            type="button"
            className="pagination-btn"
            disabled={currentPage === totalPages}
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
          >
            <FaIcons.FaChevronRight />
          </button>
        </div>

        <div className="pagination-per-page">
          <span>Show</span>

          <select
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
          </select>

          <span>per page</span>
        </div>
      </div>
    );
  };
  const renderProductTable = () => {
    return (
      <div className="products-table-wrapper">
        <table className="products-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Product</th>
              <th>Description</th>
              <th>Sub Products</th>
              <th>Modules</th>
              <th>Status</th>
              <th>Display Order</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="8" className="empty-table">
                  Loading products...
                </td>
              </tr>
            ) : filteredProducts.length === 0 ? (
              <tr>
                <td colSpan="8" className="empty-table">
                  No products found.
                </td>
              </tr>
            ) : (
              paginatedData.map((product, index) => {
                const moduleCount = (product.modules || []).reduce(
                  (total, subProduct) =>
                    total + (subProduct.subcategories?.length || 0),
                  0,
                );

                return (
                  <tr key={product.id}>
                    <td>
                      <span className="table-number">
                        {String(
                          filteredProducts.length -
                            ((currentPage - 1) * itemsPerPage + index),
                        ).padStart(2, "0")}
                      </span>
                    </td>
                    <td>
                      <div className="table-product">
                        <div className="table-product-icon">
                          <DynamicFaIcon name={product.icon} size={20} />
                        </div>

                        <div>
                          <strong>{product.name}</strong>
                        </div>
                      </div>
                    </td>

                    <td>
                      <span className="table-description">
                        {product.description || "No description"}
                      </span>
                    </td>

                    <td>
                      <span className="count-badge">
                        {product.modules?.length || 0}
                      </span>
                    </td>

                    <td>
                      <span className="count-badge">{moduleCount}</span>
                    </td>

                    <td>
                      <span
                        className={`product-status ${
                          product.status ? "active" : "inactive"
                        }`}
                      >
                        {product.status ? (
                          <>
                            <FaCheckCircle />
                            Active
                          </>
                        ) : (
                          <>
                            <FaBan />
                            Inactive
                          </>
                        )}
                      </span>
                    </td>
                    <td>
                      <span className="count-badge">
                        {product.display_order}
                      </span>
                    </td>

                    <td>
                      <div className="table-actions">
                        <button
                          className="view-btn"
                          title="View Product"
                          onClick={() => openViewProduct(product)}
                        >
                          <FaEye />
                        </button>

                        <button
                          className="edit-btn"
                          title="Edit Product"
                          onClick={() => openEditProduct(product)}
                        >
                          <FaEdit />
                        </button>

                        <button
                          className="delete-btn"
                          title="Delete Product"
                          onClick={() => deleteProduct(product.id)}
                          disabled={saving}
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    );
  };

  const renderSubProductTable = () => {
    return (
      <div className="products-table-wrapper">
        <table className="products-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Sub Product</th>
              <th>Product</th>
              <th>Description</th>
              <th>Modules</th>
              <th>Display Order</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" className="empty-table">
                  Loading sub products...
                </td>
              </tr>
            ) : filteredSubProducts.length === 0 ? (
              <tr>
                <td colSpan="7" className="empty-table">
                  No sub products found.
                </td>
              </tr>
            ) : (
              paginatedData.map((subProduct, index) => (
                <tr key={subProduct.id}>
                  <td>
                    <span className="table-number">
                      {String(
                        filteredSubProducts.length -
                          ((currentPage - 1) * itemsPerPage + index),
                      ).padStart(2, "0")}
                    </span>
                  </td>
                  <td>
                    <div className="table-product">
                      <div className="table-product-icon">
                        <DynamicFaIcon
                          name={subProduct.icon || DEFAULT_SUBPRODUCT_ICON}
                          size={20}
                        />
                      </div>

                      <div>
                        <strong>{subProduct.name}</strong>
                      </div>
                    </div>
                  </td>

                  <td>
                    <span className="parent-name">
                      {subProduct.productName}
                    </span>
                  </td>

                  <td>
                    <span className="table-description">
                      {subProduct.description || "No description"}
                    </span>
                  </td>

                  <td>
                    <span className="count-badge">
                      {subProduct.subcategories?.length || 0}
                    </span>
                  </td>
                  <td>
                    <span className="parent-name">
                      {subProduct.display_order}
                    </span>
                  </td>

                  <td>
                    <div className="table-actions">
                      <button
                        className="view-btn"
                        title="View Sub Product"
                        onClick={() => openViewSubProduct(subProduct)}
                      >
                        <FaEye />
                      </button>

                      <button
                        className="edit-btn"
                        title="Edit Sub Product"
                        onClick={() => openEditSubProduct(subProduct)}
                      >
                        <FaEdit />
                      </button>

                      <button
                        className="delete-btn"
                        title="Delete Sub Product"
                        onClick={() => deleteSubProduct(subProduct)}
                        disabled={saving}
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    );
  };

  const renderModuleTable = () => {
    return (
      <div className="products-table-wrapper">
        <table className="products-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Module</th>
              <th>Product</th>
              <th>Sub Product</th>
              <th>Price</th>
              <th>GST</th>
              <th>Code</th>
              <th>Display Order</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="9" className="empty-table">
                  Loading modules...
                </td>
              </tr>
            ) : filteredModules.length === 0 ? (
              <tr>
                <td colSpan="9" className="empty-table">
                  No modules found.
                </td>
              </tr>
            ) : (
              paginatedData.map((module, index) => (
                <tr key={module.id}>
                  <td>
                    <span className="table-number">
                      {String(
                        filteredModules.length -
                          ((currentPage - 1) * itemsPerPage + index),
                      ).padStart(2, "0")}
                    </span>
                  </td>
                  <td>
                    <div className="table-product">
                      <div
                        className={`module-table-image ${
                          module.image ? "clickable-image" : ""
                        }`}
                        onClick={() =>
                          module.image && openImagePopup(module.image)
                        }
                        title={module.image ? "Click to view image" : ""}
                      >
                        {module.image ? (
                          <img
                            src={getImageUrl(module.image)}
                            alt={module.name}
                          />
                        ) : (
                          <FaBoxOpen />
                        )}
                      </div>
                      <div>
                        <strong>{module.name}</strong>
                      </div>
                    </div>
                  </td>

                  <td>
                    <span className="parent-name">{module.productName}</span>
                  </td>

                  <td>
                    <span className="parent-name">{module.subProductName}</span>
                  </td>

                  <td>
                    {module.pricing_type === "fixed" && (
                      <span>
                        {formatModulePrice(module.prices?.[0]?.price)}
                      </span>
                    )}

                    {module.pricing_type === "yearly" && (
                      <div className="module-list-yearly-prices">
                        {module.prices
                          ?.filter((price) => price.pricing_type === "yearly")
                          .map((price, index) => (
                            <div
                              className="module-list-yearly-price"
                              key={price.id || index}
                            >
                              <span className="yearly-price-label">
                                {price.price_category === "1_year"
                                  ? "1 Year"
                                  : price.price_category === "2_years"
                                    ? "2 Years"
                                    : price.price_category}
                              </span>

                              <strong>{formatModulePrice(price.price)}</strong>
                            </div>
                          ))}
                      </div>
                    )}
                    {module.pricing_type === "single_multi_user" && (
                      <div className="module-list-yearly-prices">
                        {module.prices
                          ?.filter(
                            (price) =>
                              price.pricing_type === "single_multi_user",
                          )
                          .map((price, index) => (
                            <div
                              className="module-list-yearly-price"
                              key={price.id || index}
                            >
                              <span className="yearly-price-label">
                                {price.price_category === "single_user"
                                  ? "Single User"
                                  : price.price_category === "multi_user"
                                    ? "Multi User"
                                    : price.price_category}
                              </span>

                              <strong>{formatModulePrice(price.price)}</strong>
                            </div>
                          ))}
                      </div>
                    )}

                    {module.pricing_type === "users_wise" && (
                      <span className="pricing-type-badge">Users Wise</span>
                    )}
                  </td>
                  <td>{module.gst || ""}</td>
                  <td>{module.code || "-"}</td>
                  <td>{module.display_order}</td>

                  <td>
                    <div className="table-actions">
                      <button
                        className="view-btn"
                        title="View Module"
                        onClick={() => openViewModule(module)}
                      >
                        <FaEye />
                      </button>

                      <button
                        className="edit-btn"
                        title="Edit Module"
                        onClick={() => openEditModule(module)}
                      >
                        <FaEdit />
                      </button>

                      <button
                        className="delete-btn"
                        title="Delete Module"
                        onClick={() => deleteModule(module)}
                        disabled={saving}
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    );
  };

  const renderActiveTable = () => {
    if (activeTab === "product") {
      return renderProductTable();
    }

    if (activeTab === "subproduct") {
      return renderSubProductTable();
    }

    return renderModuleTable();
  };

  return (
    <div className="products-admin-page">
      <div className="products-admin-header" data-aos="fade-down">
        <div>
          <span className="admin-page-label">PRODUCT MANAGEMENT</span>

          <h1>Products & Solutions</h1>

          <p>Manage products, sub products and modules from one place.</p>
        </div>
      </div>

      <div className="product-stat-grid">
        <div
          className="product-stat-card"
          data-aos="fade-up"
          data-aos-delay="100"
          onClick={() => changeTab("subproduct")}
          style={{ cursor: "pointer" }}
        >
          <div className="product-stat-icon blue">
            <FaBoxOpen />
          </div>

          <div>
            <span>Total Products</span>
            <strong>{totalProducts}</strong>
          </div>
        </div>

        <div
          className="product-stat-card"
          onClick={() => changeTab("subproduct")}
          style={{ cursor: "pointer" }}
        >
          <div className="product-stat-icon yellow">
            <FaLayerGroup />
          </div>

          <div>
            <span>Total Sub Products</span>
            <strong>{totalSubProducts}</strong>
          </div>
        </div>

        <div
          className="product-stat-card"
          onClick={() => changeTab("module")}
          style={{ cursor: "pointer" }}
        >
          <div className="product-stat-icon green">
            <FaSitemap />
          </div>

          <div>
            <span>Total Modules</span>
            <strong>{totalModules}</strong>
          </div>
        </div>
      </div>

      <div
        className="products-tabs-card"
        data-aos="fade-up"
        data-aos-delay="150"
      >
        <div className="products-tabs">
          <button
            className={
              activeTab === "product" ? "products-tab active" : "products-tab"
            }
            onClick={() => changeTab("product")}
          >
            <FaBoxOpen />

            <span>Products</span>

            <strong>{totalProducts}</strong>
          </button>

          <button
            className={
              activeTab === "subproduct"
                ? "products-tab active"
                : "products-tab"
            }
            onClick={() => changeTab("subproduct")}
          >
            <FaLayerGroup />

            <span>Sub Products</span>

            <strong>{totalSubProducts}</strong>
          </button>

          <button
            className={
              activeTab === "module" ? "products-tab active" : "products-tab"
            }
            onClick={() => changeTab("module")}
          >
            <FaSitemap />

            <span>Modules</span>

            <strong>{totalModules}</strong>
          </button>
        </div>
      </div>

      <div
        className="products-admin-card"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        {/* CARD HEADER */}

        <div className="products-card-header">
          <div>
            <div className="current-section-title">
              <span className="current-section-icon">{currentTab.icon}</span>

              <div>
                <h2>{currentTab.label}</h2>

                <p>{currentTab.description}</p>
              </div>
            </div>
          </div>

          <div className="products-header-actions">
            {activeTab === "product" && (
              <button
                className="add-product-btn"
                onClick={openAddProduct}
                disabled={saving}
              >
                <FaPlus />
                Add Product
              </button>
            )}

            {activeTab === "subproduct" && (
              <button
                className="add-secondary-btn"
                onClick={openAddSubProduct}
                disabled={saving}
              >
                <FaPlus />
                Add Sub Product
              </button>
            )}

            {activeTab === "module" && (
              <button
                className="add-secondary-btn"
                onClick={openAddModule}
                disabled={saving}
              >
                <FaPlus />
                Add Module
              </button>
            )}
          </div>
        </div>

        {/* =================================================
            FILTERS
        ================================================= */}

        <div
          className="product-filters"
          data-aos="fade-up"
          data-aos-delay="250"
        >
          <div className="filter-search">
            <FaSearch />

            <input
              type="text"
              placeholder={
                activeTab === "product"
                  ? "Search product..."
                  : activeTab === "subproduct"
                    ? "Search sub product..."
                    : "Search module..."
              }
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="filter-select">
            <FaBoxOpen />

            <select
              value={productFilter}
              onChange={(e) => setProductFilter(e.target.value)}
            >
              <option value="">All Products</option>

              {products.map((product) => (
                <option key={product.id} value={product.id}>
                  {product.name}
                </option>
              ))}
            </select>
          </div>

          {activeTab === "product" && (
            <div className="filter-select">
              <FaFilter />

              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="">All Status</option>

                <option value="active">Active</option>

                <option value="inactive">Inactive</option>
              </select>
            </div>
          )}

          <button className="clear-filter-btn" onClick={clearFilters}>
            Clear
          </button>
        </div>

        {/* ACTIVE TABLE */}

        {renderActiveTable()}
        {renderPagination()}
      </div>

      {/* =====================================================
          PRODUCT MODAL
      ===================================================== */}

      {showProductModal && (
        <div className="admin-modal-overlay">
          <div className="admin-modal">
            <div className="admin-modal-header">
              <div>
                <h2>{editingProduct ? "Edit Product" : "Add New Product"}</h2>

                <p>
                  {editingProduct
                    ? "Update product information."
                    : "Create a new product."}
                </p>
              </div>

              <button className="modal-close" onClick={closeProductModal}>
                <FaTimes />
              </button>
            </div>

            <div className="admin-modal-body">
              {/* PRODUCT NAME */}

              <div className="admin-form-group">
                <label>Product Name *</label>

                <input
                  type="text"
                  value={productForm.name}
                  onChange={(e) =>
                    setProductForm({
                      ...productForm,
                      name: e.target.value,
                    })
                  }
                  placeholder="Example: TallyPrime"
                />
              </div>

              {/* PRODUCT ICON */}

              <div className="admin-form-group">
                <label>Product Icon</label>

                <div className="icon-picker">
                  <div className="selected-icon-preview">
                    <DynamicFaIcon name={productForm.icon} />

                    <div>
                      <strong>Selected Icon</strong>

                      <span>{productForm.icon}</span>
                    </div>
                  </div>

                  <div className="icon-search">
                    <FaSearch />

                    <input
                      type="text"
                      placeholder="Search icon..."
                      value={iconSearch}
                      onChange={(e) => setIconSearch(e.target.value)}
                    />
                  </div>

                  <div className="icon-grid">
                    {filteredFaIcons.map(({ name, Icon }) => (
                      <button
                        type="button"
                        key={name}
                        className={`icon-option ${
                          productForm.icon === name ? "selected" : ""
                        }`}
                        title={name}
                        onClick={() => {
                          setProductForm((prev) => ({
                            ...prev,
                            icon: name,
                          }));

                          setIconSearch("");
                        }}
                      >
                        <span className="icon-option-icon">
                          <Icon />
                        </span>

                        <span className="icon-option-name">
                          {name.replace(/^Fa/, "")}
                        </span>
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              {/* DESCRIPTION */}

              <div className="admin-form-group">
                <label>Description</label>

                <textarea
                  rows="4"
                  value={productForm.description}
                  onChange={(e) =>
                    setProductForm({
                      ...productForm,
                      description: e.target.value,
                    })
                  }
                  placeholder="Enter product description"
                />
              </div>

              {/* STATUS */}

              <div className="admin-form-group">
                <label>Status</label>

                <select
                  value={productForm.status ? "1" : "0"}
                  onChange={(e) =>
                    setProductForm({
                      ...productForm,
                      status: e.target.value === "1",
                    })
                  }
                >
                  <option value="1">Active</option>

                  <option value="0">Inactive</option>
                </select>
              </div>
              <div className="admin-form-group">
                <label>Display Order</label>

                <input
                  type="text"
                  value={productForm.display_order}
                  onChange={(e) =>
                    setProductForm({
                      ...productForm,
                      display_order: e.target.value,
                    })
                  }
                />
              </div>
            </div>

            <div className="admin-modal-footer">
              <button className="cancel-btn" onClick={closeProductModal}>
                Cancel
              </button>

              <button
                className="save-btn"
                onClick={saveProduct}
                disabled={saving}
              >
                <FaSave />

                {saving
                  ? "Saving..."
                  : editingProduct
                    ? "Update Product"
                    : "Save Product"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* =====================================================
          SUB PRODUCT MODAL
      ===================================================== */}

      {showSubProductModal && (
        <div className="admin-modal-overlay">
          <div className="admin-modal">
            <div className="admin-modal-header">
              <div>
                <h2>
                  {editingSubProduct
                    ? "Edit Sub Product"
                    : "Add New Sub Product"}
                </h2>

                <p>
                  {editingSubProduct
                    ? "Update sub product information."
                    : "Create a sub product under a product."}
                </p>
              </div>

              <button className="modal-close" onClick={closeSubProductModal}>
                <FaTimes />
              </button>
            </div>

            <div className="admin-modal-body">
              {/* PRODUCT */}

              <div className="admin-form-group">
                <label>Select Product *</label>

                <select
                  value={subProductForm.productId}
                  onChange={(e) =>
                    setSubProductForm({
                      ...subProductForm,
                      productId: e.target.value,
                    })
                  }
                >
                  <option value="">Select Product</option>

                  {products.map((product) => (
                    <option key={product.id} value={product.id}>
                      {product.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* NAME */}

              <div className="admin-form-group">
                <label>Sub Product Name *</label>

                <input
                  type="text"
                  value={subProductForm.name}
                  onChange={(e) =>
                    setSubProductForm({
                      ...subProductForm,
                      name: e.target.value,
                    })
                  }
                  placeholder="Example: New License"
                />
              </div>

              {/* ICON */}

              <div className="admin-form-group">
                <label>Sub Product Icon</label>

                <div className="icon-picker">
                  <div className="selected-icon-preview">
                    <DynamicFaIcon name={subProductForm.icon} />

                    <div>
                      <strong>Selected Icon</strong>

                      <span>{subProductForm.icon}</span>
                    </div>
                  </div>

                  <div className="icon-search">
                    <FaSearch />

                    <input
                      type="text"
                      placeholder="Search icon..."
                      value={iconSearch}
                      onChange={(e) => setIconSearch(e.target.value)}
                    />
                  </div>

                  <div className="icon-grid">
                    {filteredFaIcons.map(({ name, Icon }) => (
                      <button
                        type="button"
                        key={name}
                        className={`icon-option ${
                          subProductForm.icon === name ? "selected" : ""
                        }`}
                        title={name}
                        onClick={() => {
                          setSubProductForm((prev) => ({
                            ...prev,
                            icon: name,
                          }));

                          setIconSearch("");
                        }}
                      >
                        <span className="icon-option-icon">
                          <Icon />
                        </span>

                        <span className="icon-option-name">
                          {name.replace(/^Fa/, "")}
                        </span>
                      </button>
                    ))}
                  </div>
                </div>
              </div>
              <div className="admin-form-group">
                <label>Description</label>
                <textarea
                  rows="4"
                  value={subProductForm.description}
                  onChange={(e) =>
                    setSubProductForm({
                      ...subProductForm,
                      description: e.target.value,
                    })
                  }
                  placeholder="Enter sub product description"
                />
              </div>
              <div className="admin-form-group">
                <label>Display_order </label>
                <input
                  type="text"
                  value={subProductForm.display_order}
                  onChange={(e) =>
                    setSubProductForm({
                      ...subProductForm,
                      display_order: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="admin-modal-footer">
              <button className="cancel-btn" onClick={closeSubProductModal}>
                Cancel
              </button>
              <button
                className="save-btn"
                onClick={saveSubProduct}
                disabled={saving}
              >
                <FaSave />
                {saving
                  ? "Saving..."
                  : editingSubProduct
                    ? "Update Sub Product"
                    : "Save Sub Product"}
              </button>
            </div>
          </div>
        </div>
      )}
      {showModuleModal && (
        <div className="admin-modal-overlay">
          <div className="admin-modal plan-modal">
            <div className="admin-modal-header">
              <div>
                <h2>{editingModule ? "Edit Module" : "Add New Module"}</h2>
                <p>
                  {editingModule
                    ? "Update module information."
                    : "Add a module under a sub product."}
                </p>
              </div>
              <button className="modal-close" onClick={closeModuleModal}>
                <FaTimes />
              </button>
            </div>
            <div className="admin-modal-body">
              <div className="admin-form-row">
                <div className="admin-form-group">
                  <label>Select Product *</label>
                  <select
                    value={moduleForm.productId}
                    onChange={(e) =>
                      setModuleForm({
                        ...moduleForm,
                        productId: e.target.value,
                        subProductId: "",
                      })
                    }
                  >
                    <option value="">Select Product</option>
                    {products.map((product) => (
                      <option key={product.id} value={product.id}>
                        {product.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="admin-form-group">
                  <label>Select Sub Product *</label>
                  <select
                    value={moduleForm.subProductId}
                    disabled={!moduleForm.productId}
                    onChange={(e) =>
                      setModuleForm({
                        ...moduleForm,
                        subProductId: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Sub Product</option>
                    {selectedSubProductList.map((subProduct) => (
                      <option key={subProduct.id} value={subProduct.id}>
                        {subProduct.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="admin-form-group">
                <label>Module Name *</label>

                <input
                  type="text"
                  value={moduleForm.name}
                  onChange={(e) =>
                    setModuleForm({
                      ...moduleForm,
                      name: e.target.value,
                    })
                  }
                  placeholder="Example: Silver - Single User"
                />
              </div>
              {/* DESCRIPTION */}
              <label className="module-description-editor-label">
                Description
                <div className="module-tiptap-wrapper">
                  {/* TOOLBAR */}
                  <div className="module-tiptap-toolbar">
                    {/* BOLD */}
                    <button
                      type="button"
                      className={
                        moduleDescriptionEditor?.isActive("bold")
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        moduleDescriptionEditor
                          ?.chain()
                          .focus()
                          .toggleBold()
                          .run()
                      }
                      title="Bold"
                    >
                      <strong>B</strong>
                    </button>

                    {/* ITALIC */}
                    <button
                      type="button"
                      className={
                        moduleDescriptionEditor?.isActive("italic")
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        moduleDescriptionEditor
                          ?.chain()
                          .focus()
                          .toggleItalic()
                          .run()
                      }
                      title="Italic"
                    >
                      <em>I</em>
                    </button>

                    {/* UNDERLINE */}
                    <button
                      type="button"
                      className={
                        moduleDescriptionEditor?.isActive("underline")
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        moduleDescriptionEditor
                          ?.chain()
                          .focus()
                          .toggleUnderline()
                          .run()
                      }
                      title="Underline"
                    >
                      <u>U</u>
                    </button>

                    <span className="module-toolbar-divider" />

                    {/* TEXT COLOR */}
                    <label className="module-color-picker" title="Text Color">
                      <span>A</span>

                      <input
                        type="color"
                        value="#000000"
                        onChange={(e) => {
                          moduleDescriptionEditor
                            ?.chain()
                            .focus()
                            .setColor(e.target.value)
                            .run();
                        }}
                      />
                    </label>

                    {/* HIGHLIGHT */}
                    <label
                      className="module-color-picker highlight-picker"
                      title="Highlight Color"
                    >
                      <span
                        style={{
                          backgroundColor: moduleHighlightColor,
                          color: "#000",
                        }}
                      >
                        H
                      </span>

                      <input
                        type="color"
                        value={moduleHighlightColor}
                        onChange={(e) => {
                          const color = e.target.value;

                          setModuleHighlightColor(color);

                          moduleDescriptionEditor
                            ?.chain()
                            .focus()
                            .toggleHighlight({
                              color: color,
                            })
                            .run();
                        }}
                      />
                    </label>

                    <span className="module-toolbar-divider" />

                    {/* BULLET LIST */}
                    <button
                      type="button"
                      className={
                        moduleDescriptionEditor?.isActive("bulletList")
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        moduleDescriptionEditor
                          ?.chain()
                          .focus()
                          .toggleBulletList()
                          .run()
                      }
                      title="Bullet List"
                    >
                      •☰
                    </button>

                    {/* NUMBERED LIST */}
                    <button
                      type="button"
                      className={
                        moduleDescriptionEditor?.isActive("orderedList")
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        moduleDescriptionEditor
                          ?.chain()
                          .focus()
                          .toggleOrderedList()
                          .run()
                      }
                      title="Numbered List"
                    >
                      1.
                    </button>

                    <span className="module-toolbar-divider" />

                    {/* LEFT */}
                    <button
                      type="button"
                      className={
                        moduleDescriptionEditor?.isActive({
                          textAlign: "left",
                        })
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        moduleDescriptionEditor
                          ?.chain()
                          .focus()
                          .setTextAlign("left")
                          .run()
                      }
                      title="Align Left"
                    >
                      L
                    </button>

                    {/* CENTER */}
                    <button
                      type="button"
                      className={
                        moduleDescriptionEditor?.isActive({
                          textAlign: "center",
                        })
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        moduleDescriptionEditor
                          ?.chain()
                          .focus()
                          .setTextAlign("center")
                          .run()
                      }
                      title="Align Center"
                    >
                      C
                    </button>

                    {/* RIGHT */}
                    <button
                      type="button"
                      className={
                        moduleDescriptionEditor?.isActive({
                          textAlign: "right",
                        })
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        moduleDescriptionEditor
                          ?.chain()
                          .focus()
                          .setTextAlign("right")
                          .run()
                      }
                      title="Align Right"
                    >
                      R
                    </button>

                    <span className="module-toolbar-divider" />

                    {/* CLEAR */}
                    <button
                      type="button"
                      onClick={() =>
                        moduleDescriptionEditor
                          ?.chain()
                          .focus()
                          .unsetAllMarks()
                          .clearNodes()
                          .run()
                      }
                      title="Clear Formatting"
                    >
                      Clear
                    </button>
                  </div>

                  {/* EDITABLE AREA */}
                  <EditorContent editor={moduleDescriptionEditor} />
                </div>
              </label>
              <div className="admin-form-group">
                <label>Pricing Type *</label>
                <select
                  value={moduleForm.pricing_type}
                  onChange={(e) => {
                    const pricing_type = e.target.value;
                    setModuleForm((prev) => ({
                      ...prev,
                      pricing_type,
                      singlePrice: "",
                      oneYearPrice: "",
                      twoYearPrice: "",
                      priceCategory: "new",
                      usersWisePrices: createEmptyUsersWisePrices(),
                    }));
                  }}
                >
                  <option value="fixed">Fixed (Same Price)</option>
                  <option value="single_multi_user">
                    Single / Multi User Price
                  </option>
                  <option value="yearly">Years Wise</option>
                  <option value="users_wise">Users Wise</option>
                </select>
              </div>
              {moduleForm.pricing_type === "yearly" && (
                <div className="admin-form-row">
                  <div className="admin-form-group">
                    <label>1 Year Price</label>
                    <input
                      type="text"
                      min="0"
                      step="0.01"
                      value={moduleForm.oneYearPrice}
                      onChange={(e) =>
                        setModuleForm((prev) => ({
                          ...prev,
                          oneYearPrice: e.target.value,
                        }))
                      }
                      placeholder="Enter 1 year price"
                    />
                  </div>
                  <div className="admin-form-group">
                    <label>2 Years Price</label>
                    <input
                      type="text"
                      value={moduleForm.twoYearPrice}
                      onChange={(e) =>
                        setModuleForm((prev) => ({
                          ...prev,
                          twoYearPrice: e.target.value,
                        }))
                      }
                      placeholder="Enter 2 years price"
                    />
                  </div>
                </div>
              )}
              {moduleForm.pricing_type === "fixed" && (
                <div className="admin-form-row">
                  <div className="admin-form-group">
                    <label>Price</label>
                    <input
                      type="text"
                      value={moduleForm.singlePrice}
                      onChange={(e) =>
                        setModuleForm((prev) => ({
                          ...prev,
                          singlePrice: e.target.value,
                        }))
                      }
                      placeholder="Enter price"
                    />
                  </div>
                  <div className="admin-form-group">
                    <label>GST</label>
                    <input
                      value={moduleForm.gst}
                      onChange={(e) =>
                        setModuleForm((prev) => ({
                          ...prev,
                          gst: e.target.value,
                        }))
                      }
                      placeholder="Example: 18%"
                    />
                  </div>

                  <div className="admin-form-group">
                    <label>Code</label>

                    <input
                      type="text"
                      value={moduleForm.code}
                      onChange={(e) =>
                        setModuleForm((prev) => ({
                          ...prev,
                          code: e.target.value,
                        }))
                      }
                      placeholder="Example: TALLY-SILVER"
                    />
                  </div>
                </div>
              )}
              {moduleForm.pricing_type === "single_multi_user" && (
                <>
                  <div className="admin-form-row">
                    <div className="admin-form-group">
                      <label>Single User Price</label>
                      <input
                        type="text"
                        value={moduleForm.singleUserPrice}
                        onChange={(e) =>
                          setModuleForm((prev) => ({
                            ...prev,
                            singleUserPrice: e.target.value,
                          }))
                        }
                        placeholder="Enter single user price"
                      />
                    </div>

                    <div className="admin-form-group">
                      <label>Multi User Price</label>
                      <input
                        type="text"
                        value={moduleForm.multiUserPrice}
                        onChange={(e) =>
                          setModuleForm((prev) => ({
                            ...prev,
                            multiUserPrice: e.target.value,
                          }))
                        }
                        placeholder="Enter multi user price"
                      />
                    </div>
                  </div>

                  <div className="admin-form-row">
                    <div className="admin-form-group">
                      <label>GST</label>
                      <input
                        type="text"
                        value={moduleForm.gst}
                        onChange={(e) =>
                          setModuleForm((prev) => ({
                            ...prev,
                            gst: e.target.value,
                          }))
                        }
                        placeholder="Example: 18%"
                      />
                    </div>

                    <div className="admin-form-group">
                      <label>Code</label>
                      <input
                        type="text"
                        value={moduleForm.code}
                        onChange={(e) =>
                          setModuleForm((prev) => ({
                            ...prev,
                            code: e.target.value,
                          }))
                        }
                        placeholder="Example: TALLY-SILVER"
                      />
                    </div>
                  </div>
                </>
              )}
              {moduleForm.pricing_type === "yearly" && (
                <div className="admin-form-row">
                  <div className="admin-form-group">
                    <label>GST</label>
                    <input
                      value={moduleForm.gst}
                      onChange={(e) =>
                        setModuleForm((prev) => ({
                          ...prev,
                          gst: e.target.value,
                        }))
                      }
                      placeholder="Example: 18%"
                    />
                  </div>
                  <div className="admin-form-group">
                    <label>Code</label>
                    <input
                      value={moduleForm.code}
                      onChange={(e) =>
                        setModuleForm((prev) => ({
                          ...prev,
                          code: e.target.value,
                        }))
                      }
                      placeholder="Example: TALLY-YEARLY"
                    />
                  </div>
                </div>
              )}
              {/* {moduleForm.pricing_type === "users_wise" && (
                <>
                  <div className="admin-form-group">
                    <label>Price Category</label>
                    <div className="pricing-category-tabs">
                      <button
                        type="button"
                        className={
                          moduleForm.priceCategory === "new"
                            ? "pricing-category-btn active"
                            : "pricing-category-btn"
                        }
                        onClick={() =>
                          setModuleForm((prev) => ({
                            ...prev,
                            priceCategory: "new",
                          }))
                        }
                      >
                        New
                      </button>
                      <button
                        type="button"
                        className={
                          moduleForm.priceCategory === "renewal"
                            ? "pricing-category-btn active"
                            : "pricing-category-btn"
                        }
                        onClick={() =>
                          setModuleForm((prev) => ({
                            ...prev,
                            priceCategory: "renewal",
                          }))
                        }
                      >
                        Renewal
                      </button>
                    </div>
                  </div>
                  {USERS_WISE_PLANS.map((pack) => (
                    <div className="users-wise-pack" key={pack.pack_name}>
                      <div className="users-wise-pack-header">
                        <h3>{pack.pack_name}</h3>
                      </div>
                      <div className="users-wise-plan-list">
                        {pack.plans.map((plan) => {
                          const key = getPlanKey(
                            moduleForm.priceCategory,
                            pack.pack_name,
                            plan.plan_name,
                          );
                          const price = moduleForm.usersWisePrices?.[key] ?? "";
                          return (
                            <div
                              className="users-wise-plan-row"
                              key={`${moduleForm.priceCategory}-${pack.pack_name}-${plan.plan_name}`}
                            >
                              <div className="users-wise-plan-info">
                                <strong>{plan.plan_name}</strong>

                                <span>{plan.user_count} User</span>
                              </div>

                              <div className="users-wise-plan-price">
                                <span>₹</span>

                                <input
                                  type="number"
                                  min="0"
                                  step="0.01"
                                  value={price}
                                  onChange={(e) =>
                                    updateUsersWisePrice(
                                      pack.pack_name,
                                      plan.plan_name,
                                      e.target.value,
                                    )
                                  }
                                  placeholder="Enter price"
                                />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                  <div className="admin-form-row">
                    <div className="admin-form-group">
                      <label>GST</label>

                      <input
                        type="text"
                        value={moduleForm.gst}
                        onChange={(e) =>
                          setModuleForm((prev) => ({
                            ...prev,
                            gst: e.target.value,
                          }))
                        }
                        placeholder="Example: 18%"
                      />
                    </div>

                    <div className="admin-form-group">
                      <label>Code</label>

                      <input
                        type="text"
                        value={moduleForm.code}
                        onChange={(e) =>
                          setModuleForm((prev) => ({
                            ...prev,
                            code: e.target.value,
                          }))
                        }
                        placeholder="Example: TALLY-SILVER"
                      />
                    </div>
                  </div>
                </>
              )} */}
              {moduleForm.pricing_type === "users_wise" && (
                <>
                  <div className="admin-form-group">
                    <label>Price Category</label>
                    <div
                      className="admin-form-group"
                      style={{
                        marginBottom: "0px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div className="pricing-category-tabs">
                        <button
                          type="button"
                          className={
                            moduleForm.priceCategory === "new"
                              ? "pricing-category-btn active"
                              : "pricing-category-btn"
                          }
                          onClick={() =>
                            setModuleForm((prev) => ({
                              ...prev,
                              priceCategory: "new",
                            }))
                          }
                        >
                          New
                        </button>

                        <button
                          type="button"
                          className={
                            moduleForm.priceCategory === "renewal"
                              ? "pricing-category-btn active"
                              : "pricing-category-btn"
                          }
                          onClick={() =>
                            setModuleForm((prev) => ({
                              ...prev,
                              priceCategory: "renewal",
                            }))
                          }
                        >
                          Renewal
                        </button>
                      </div>
                      <div className="users-wise-pack-tabs">
                        {USERS_WISE_PLANS.map((pack) => (
                          <button
                            type="button"
                            key={pack.pack_name}
                            className={
                              selectedUsersWisePack === pack.pack_name
                                ? "users-wise-pack-tab active"
                                : "users-wise-pack-tab"
                            }
                            onClick={() =>
                              setSelectedUsersWisePack(pack.pack_name)
                            }
                          >
                            {pack.pack_name}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>

                  {USERS_WISE_PLANS.filter(
                    (pack) => pack.pack_name === selectedUsersWisePack,
                  ).map((pack) => (
                    <div className="users-wise-pack" key={pack.pack_name}>
                      <div className="users-wise-plan-list">
                        {pack.plans.map((plan) => {
                          const key = getPlanKey(
                            moduleForm.priceCategory,
                            pack.pack_name,
                            plan.plan_name,
                          );

                          const price = moduleForm.usersWisePrices?.[key] ?? "";

                          return (
                            <div
                              className="users-wise-plan-row"
                              key={`${moduleForm.priceCategory}-${pack.pack_name}-${plan.plan_name}`}
                            >
                              <div className="users-wise-plan-info">
                                <strong>{plan.plan_name}</strong>

                                {/* <span>{plan.user_count} User</span> */}
                              </div>

                              <div className="users-wise-plan-price">
                                <span>₹</span>

                                <input
                                  value={price}
                                  onChange={(e) =>
                                    updateUsersWisePrice(
                                      pack.pack_name,
                                      plan.plan_name,
                                      e.target.value,
                                    )
                                  }
                                  placeholder="Enter price"
                                />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}

                  {/* GST + CODE */}
                  <div className="admin-form-row">
                    <div className="admin-form-group">
                      <label>GST</label>

                      <input
                        type="text"
                        value={moduleForm.gst}
                        onChange={(e) =>
                          setModuleForm((prev) => ({
                            ...prev,
                            gst: e.target.value,
                          }))
                        }
                        placeholder="Example: 18%"
                      />
                    </div>

                    <div className="admin-form-group">
                      <label>Code</label>

                      <input
                        type="text"
                        value={moduleForm.code}
                        onChange={(e) =>
                          setModuleForm((prev) => ({
                            ...prev,
                            code: e.target.value,
                          }))
                        }
                        placeholder="Example: TALLY-SILVER"
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="admin-form-group">
                <label>Module Image</label>
                <div className="simple-upload">
                  {moduleForm.imagePreview && (
                    <img src={moduleForm.imagePreview} alt="Module Preview" />
                  )}

                  <label className="upload-file-btn">
                    Choose Image
                    <input
                      type="file"
                      accept="image/*"
                      hidden
                      onChange={handleModuleImage}
                    />
                  </label>
                </div>
              </div>
              <div className="admin-form-group">
                <label>Display Order</label>
                <input
                  type="text"
                  value={moduleForm.display_order}
                  onChange={(e) =>
                    setModuleForm({
                      ...moduleForm,
                      display_order: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="admin-modal-footer">
              <button className="cancel-btn" onClick={closeModuleModal}>
                Cancel
              </button>
              <button
                className="save-btn"
                onClick={saveModule}
                disabled={saving}
              >
                <FaSave />
                {saving
                  ? "Saving..."
                  : editingModule
                    ? "Update Module"
                    : "Save Module"}
              </button>
            </div>
          </div>
        </div>
      )}
      {showViewModal && (
        <div className="admin-modal-overlay">
          <div className="admin-modal large-modal">
            {selectedProduct && (
              <>
                <div className="admin-modal-header">
                  <div>
                    <h2>{selectedProduct.name}</h2>

                    <p>{selectedProduct.description || "Product details"}</p>
                  </div>
                  <button className="modal-close" onClick={closeViewModal}>
                    <FaTimes />
                  </button>
                </div>
                <div className="view-product-content">
                  {selectedProduct.modules?.length === 0 ? (
                    <div className="empty-details">
                      No sub products added for this product.
                    </div>
                  ) : (
                    selectedProduct.modules.map((subProduct) => (
                      <div className="view-module" key={subProduct.id}>
                        <div className="view-module-header">
                          <div>
                            <span>SUB PRODUCT</span>
                            <h3>{subProduct.name}</h3>
                            {subProduct.description && (
                              <p>{subProduct.description}</p>
                            )}
                          </div>
                          <span className="module-count">
                            {subProduct.subcategories?.length || 0} Modules
                          </span>
                        </div>
                        {subProduct.subcategories?.length > 0 && (
                          <div className="view-subcategory-list">
                            {subProduct.subcategories.map((module) => (
                              <div className="view-subcategory" key={module.id}>
                                <div
                                  className={`subcategory-image ${
                                    module.image ? "clickable-image" : ""
                                  }`}
                                  onClick={() =>
                                    module.image && openImagePopup(module.image)
                                  }
                                  title={
                                    module.image ? "Click to view image" : ""
                                  }
                                >
                                  {module.image ? (
                                    <img
                                      src={getImageUrl(module.image)}
                                      alt={module.name}
                                    />
                                  ) : (
                                    <FaSitemap />
                                  )}
                                </div>
                                <div className="subcategory-info">
                                  <h4>{module.name}</h4>
                                  <p>
                                    {module.description ? (
                                      <div
                                        className="product-module-rich-description"
                                        dangerouslySetInnerHTML={{
                                          __html: module.description,
                                        }}
                                      />
                                    ) : (
                                      <p>No description</p>
                                    )}
                                  </p>
                                  <div className="subcategory-meta">
                                    {module.pricing_type === "fixed" && (
                                      <span>
                                        <strong>Price:</strong>{" "}
                                        {module.prices?.[0]?.price
                                          ? `₹${module.prices[0].price}`
                                          : "Price on request"}
                                      </span>
                                    )}
                                    {module.pricing_type === "1_year" && (
                                      <span>
                                        <strong>Price:</strong>{" "}
                                        {module.prices?.[0]?.price
                                          ? `₹${module.prices[0].price} / 1 Year`
                                          : "Price on request"}
                                      </span>
                                    )}
                                    {module.pricing_type === "2_years" && (
                                      <span>
                                        <strong>Price:</strong>{" "}
                                        {module.prices?.[0]?.price
                                          ? `₹${module.prices[0].price} / 2 Years`
                                          : "Price on request"}
                                      </span>
                                    )}
                                    {module.pricing_type ===
                                      "single_multi_user" && (
                                      <div className="module-single-multi-prices">
                                        {(module.prices || [])
                                          .filter(
                                            (price) =>
                                              price.pricing_type ===
                                              "single_multi_user",
                                          )
                                          .map((price, index) => (
                                            <div
                                              className="module-single-multi-price"
                                              key={price.id || index}
                                            >
                                              <span className="module-price-label">
                                                {price.price_category ===
                                                "single_user"
                                                  ? "Single User"
                                                  : price.price_category ===
                                                      "multi_user"
                                                    ? "Multi User"
                                                    : price.price_category}
                                              </span>

                                              <strong>
                                                {formatModulePrice(price.price)}
                                              </strong>
                                            </div>
                                          ))}
                                      </div>
                                    )}
                                    {module.pricing_type === "users_wise" && (
                                      <span>
                                        <strong>Pricing:</strong> Users Wise
                                      </span>
                                    )}
                                    {module.code && (
                                      <span>
                                        <strong>Code:</strong> {module.code}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))
                  )}
                </div>
              </>
            )}
            {selectedSubProduct && (
              <>
                <div className="admin-modal-header">
                  <div>
                    <span className="admin-page-label">SUB PRODUCT</span>
                    <h2>{selectedSubProduct.name}</h2>
                    <p>Product: {selectedSubProduct.productName}</p>
                  </div>
                  <button className="modal-close" onClick={closeViewModal}>
                    <FaTimes />
                  </button>
                </div>
                <div className="view-product-content">
                  <div className="view-module">
                    <div className="view-module-header">
                      <div>
                        <span>SUB PRODUCT</span>
                        <h3>{selectedSubProduct.name}</h3>
                        <p>
                          {selectedSubProduct.description || "No description"}
                        </p>
                      </div>
                      <span className="module-count">
                        {selectedSubProduct.subcategories?.length || 0} Modules
                      </span>
                    </div>
                    {selectedSubProduct.subcategories?.length > 0 ? (
                      <div className="view-subcategory-list">
                        {selectedSubProduct.subcategories.map((module) => (
                          <div className="view-subcategory" key={module.id}>
                            <div
                              className={`subcategory-image ${
                                module.image ? "clickable-image" : ""
                              }`}
                              onClick={() =>
                                module.image && openImagePopup(module.image)
                              }
                              title={module.image ? "Click to view image" : ""}
                            >
                              {module.image ? (
                                <img
                                  src={getImageUrl(module.image)}
                                  alt={module.name}
                                />
                              ) : (
                                <FaSitemap />
                              )}
                            </div>
                            <div className="subcategory-info">
                              <h4>{module.name}</h4>
                              <p>
                                {module.description ? (
                                  <div
                                    className="product-module-rich-description"
                                    dangerouslySetInnerHTML={{
                                      __html: module.description,
                                    }}
                                  />
                                ) : (
                                  <p>No description</p>
                                )}
                              </p>
                              <div className="subcategory-meta">
                                {module.pricing_type === "fixed" && (
                                  <span>
                                    <strong>Price:</strong>{" "}
                                    {module.prices?.[0]?.price
                                      ? `₹${module.prices[0].price}`
                                      : "Price on request"}
                                  </span>
                                )}
                                {module.pricing_type === "1_year" && (
                                  <span>
                                    <strong>Price:</strong>{" "}
                                    {module.prices?.[0]?.price
                                      ? `₹${module.prices[0].price} / 1 Year`
                                      : "Price on request"}
                                  </span>
                                )}
                                {module.pricing_type === "2_years" && (
                                  <span>
                                    <strong>Price:</strong>{" "}
                                    {module.prices?.[0]?.price
                                      ? `₹${module.prices[0].price} / 2 Years`
                                      : "Price on request"}
                                  </span>
                                )}
                                {module.pricing_type ===
                                  "single_multi_user" && (
                                  <div className="module-single-multi-prices">
                                    {(module.prices || [])
                                      .filter(
                                        (price) =>
                                          price.pricing_type ===
                                          "single_multi_user",
                                      )
                                      .map((price, index) => (
                                        <div
                                          className="module-single-multi-price"
                                          key={price.id || index}
                                        >
                                          <span className="module-price-label">
                                            {price.price_category ===
                                            "single_user"
                                              ? "Single User"
                                              : price.price_category ===
                                                  "multi_user"
                                                ? "Multi User"
                                                : price.price_category}
                                          </span>

                                          <strong>
                                            {formatModulePrice(price.price)}
                                          </strong>
                                        </div>
                                      ))}
                                  </div>
                                )}
                                {module.pricing_type === "users_wise" && (
                                  <span>
                                    <strong>Pricing:</strong> Users Wise
                                  </span>
                                )}

                                {module.code && (
                                  <span>
                                    <strong>Code:</strong> {module.code}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="empty-details">
                        No modules added to this sub product.
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
            {selectedModule && (
              <>
                <div className="view-product-content">
                  <div className="view-module">
                    <div className="view-subcategory">
                      <div className="subcategory-image">
                        {selectedModule.image ? (
                          <img
                            src={getImageUrl(selectedModule.image)}
                            alt={selectedModule.name}
                          />
                        ) : (
                          <FaSitemap />
                        )}
                      </div>
                      <div className="subcategory-info">
                        <span>PRODUCT</span>
                        <h4>{selectedModule.productName}</h4>
                        <span>SUB PRODUCT</span>
                        <h4>{selectedModule.subProductName}</h4>
                        <h3>{selectedModule.name}</h3>
                        <p>
                          {selectedModule.description ? (
                            <div
                              className="product-module-rich-description"
                              dangerouslySetInnerHTML={{
                                __html: selectedModule.description,
                              }}
                            />
                          ) : (
                            <p>No description</p>
                          )}
                        </p>
                        <div className="subcategory-meta">
                          <span>
                            <strong>Pricing Type:</strong>{" "}
                            {selectedModule.pricing_type === "yearly"
                              ? "Yearly"
                              : selectedModule.pricing_type === "users_wise"
                                ? "Users Wise"
                                : selectedModule.pricing_type ===
                                    "single_multi_user"
                                  ? "Single / Multi User"
                                  : "Fixed"}
                          </span>
                          <span>
                            <strong>GST:</strong> {selectedModule.gst || "—"}
                          </span>
                          {selectedModule.code && (
                            <span>
                              <strong>Code:</strong> {selectedModule.code}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    {selectedModule.pricing_type === "fixed" && (
                      <div className="module-price-section">
                        <div className="module-price-section-header">
                          <h3>Price</h3>
                        </div>

                        <div className="module-price-table-wrapper">
                          <table className="module-price-table">
                            <thead>
                              <tr>
                                <th>Pricing</th>
                                <th>Price</th>
                              </tr>
                            </thead>

                            <tbody>
                              {(selectedModule.prices || []).map(
                                (price, index) => (
                                  <tr key={price.id || index}>
                                    <td>Fixed Price</td>

                                    <td>{formatModulePrice(price.price)}</td>
                                  </tr>
                                ),
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                    {selectedModule.pricing_type === "yearly" && (
                      <div className="module-price-section">
                        <div className="module-price-section-header">
                          <h3>Yearly Pricing</h3>
                        </div>

                        <div className="module-price-table-wrapper">
                          <table className="module-price-table">
                            <thead>
                              <tr>
                                <th>Duration</th>
                                <th>Price</th>
                              </tr>
                            </thead>

                            <tbody>
                              {(selectedModule.prices || [])
                                .filter(
                                  (item) => item.pricing_type === "yearly",
                                )
                                .map((price, index) => (
                                  <tr key={price.id || index}>
                                    <td>
                                      {price.price_category === "1_year"
                                        ? "1 Year"
                                        : price.price_category === "2_years"
                                          ? "2 Years"
                                          : price.price_category}
                                    </td>

                                    <td>{formatModulePrice(price.price)}</td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                    {selectedModule.pricing_type === "single_multi_user" && (
                      <div className="module-price-section">
                        <div className="module-price-section-header">
                          <h3>Single / Multi User Pricing</h3>
                        </div>

                        <div className="module-price-table-wrapper">
                          <table className="module-price-table">
                            <thead>
                              <tr>
                                <th>User Type</th>
                                <th>Price</th>
                              </tr>
                            </thead>

                            <tbody>
                              {(selectedModule.prices || [])
                                .filter(
                                  (item) =>
                                    item.pricing_type === "single_multi_user",
                                )
                                .map((price, index) => (
                                  <tr key={price.id || index}>
                                    <td>
                                      {price.price_category === "single_user"
                                        ? "Single User"
                                        : price.price_category === "multi_user"
                                          ? "Multi User"
                                          : price.price_category}
                                    </td>

                                    <td>{formatModulePrice(price.price)}</td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                    {selectedModule.pricing_type === "users_wise" && (
                      <div className="module-price-section">
                        <div className="module-price-section-header">
                          <h3>Users Wise Pricing</h3>
                        </div>

                        <div className="module-price-table-wrapper">
                          <table className="module-price-table">
                            <thead>
                              <tr>
                                <th>Category</th>
                                <th>Pack</th>
                                <th>Plan</th>
                                <th>Users</th>
                                <th>Price</th>
                              </tr>
                            </thead>

                            <tbody>
                              {(selectedModule.prices || [])
                                .filter(
                                  (item) =>
                                    item.pricing_type === "users_wise" &&
                                    item.price !== null &&
                                    item.price !== undefined,
                                )
                                .map((price, index) => (
                                  <tr key={price.id || index}>
                                    <td>
                                      <span
                                        className={
                                          price.price_category === "new"
                                            ? "price-category-badge new"
                                            : "price-category-badge renewal"
                                        }
                                      >
                                        {price.price_category === "new"
                                          ? "New"
                                          : "Renewal"}
                                      </span>
                                    </td>

                                    <td>{price.pack_name || "—"}</td>

                                    <td>{price.plan_name || "—"}</td>

                                    <td>
                                      {price.user_count
                                        ? `${price.user_count} User`
                                        : "—"}
                                    </td>

                                    <td>{formatModulePrice(price.price)}</td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
            <div className="admin-modal-footer">
              <button className="cancel-btn" onClick={closeViewModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {showImageModal && selectedImage && (
        <div className="image-preview-overlay" onClick={closeImagePopup}>
          <div
            className="image-preview-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="image-preview-close"
              onClick={closeImagePopup}
              title="Close"
            >
              <FaTimes />
            </button>

            <div className="image-preview-content">
              <img src={selectedImage} alt="Preview" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
